import React from 'react';

interface ActiveJobsBadgeProps {
  count: number;
  /** issue #84 提案A (差し替え可能): 渡すとバッジを button 化し、 タップで履歴を開く動線にする。 */
  onClick?: () => void;
}

/**
 * issue #84 要望1: 投入中ジョブ件数の控えめなインジケータ。
 * count < 1 のとき非表示。前回結果ブロックとは独立に配置する。
 */
const ActiveJobsBadge: React.FC<ActiveJobsBadgeProps> = ({ count, onClick }) => {
  if (count < 1) return null;

  const label = `🔄 投入中 ${count} 件`;
  const baseClass =
    'inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold bg-primary-50 text-primary-700 border border-primary-200';

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${baseClass} hover:bg-primary-100 transition-colors`}>
        {label}
      </button>
    );
  }
  return <span className={baseClass}>{label}</span>;
};

export default ActiveJobsBadge;
